module.exports = {
  API_BASE_URL: "/api",
  // 正式环境后端地址（后台页面本身走相对路径 /api，这里用于拼接图片等绝对地址、以及本地起服务时的代理目标）。
  // 本地联调改成 http://127.0.0.1:8088（prod 配置的后端）或 http://127.0.0.1:7070（dev/test 配置）。
  BACKEND_ORIGIN: "https://md.ddcloudrack.com:9999"
}
